import { Info } from "lucide-react";
import { DRAFT_MODE } from "@/content/site";

export const DraftNote = ({ children, dark = false, testId }) => {
  if (!DRAFT_MODE) return null;
  return (
    <p
      data-testid={testId}
      className={`inline-flex items-start gap-2 border border-dashed px-3 py-2 text-xs leading-relaxed ${
        dark ? "border-[#C9A66B]/50 text-[#E5D3B3]" : "border-[#8A6C3E]/50 text-[#6E5530]"
      }`}
    >
      <Info className="mt-0.5 h-3.5 w-3.5 shrink-0" aria-hidden="true" />
      <span>{children}</span>
    </p>
  );
};

export const SectionHead = ({ eyebrow, index, children, dark = false }) => (
  <div className="flex items-center gap-4">
    <span className={`font-serif-it text-2xl ${dark ? "text-[#C9A66B]" : "text-[#8A6C3E]"}`}>{index}</span>
    <span className={`h-px w-10 ${dark ? "bg-[#C9A66B]/60" : "bg-[#8A6C3E]/50"}`} />
    <span className={`eyebrow ${dark ? "text-[#C9A66B]" : "text-[#8A6C3E]"}`}>{eyebrow}</span>
    {children}
  </div>
);
